import styled from "styled-components"

const StyledPageHeader = styled.div``

export default StyledPageHeader
